import * as React from 'react'

import { Tooltip, EXTRA_SMALL_ICON_BASE_SRC, } from '../../../../Shared/index'

const renameSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/rename.svg`
const shareActivitySrc = `${EXTRA_SMALL_ICON_BASE_SRC}/share.svg`
const deleteActivityPackSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/trash.svg`
const closeActivityPackSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/close.svg`
const openActivityPackSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/open.svg`

const ActivityPackUpdateButtons = ({
  handleClickShareActivityPack,
  handleClickShowRename,
  handleClickShowRemove,
  handleClickShowReopenUnit,
  handleClickShowCloseUnit,
  isOpen
}) => {
  const shareButton = (
    <button className="quill-button borderless small grey icon focus-on-light" onClick={handleClickShareActivityPack} type="button">
      <img alt="Share icon" src={shareActivitySrc} />
      <span>Share Activity Pack</span>
    </button>
  )

  const renameButton = (
    <button className="quill-button borderless small grey icon focus-on-light" onClick={handleClickShowRename} type="button">
      <img alt="Rename icon" src={renameSrc} />
      <span>Rename Activity Pack</span>
    </button>
  )

  const closeButton = (
    <button className="quill-button borderless small grey icon focus-on-light" onClick={handleClickShowCloseUnit} type="button">
      <img alt="" src={closeActivityPackSrc} />
      <span>Close Activity Pack</span>
    </button>
  )

  const closeElement = (
    <Tooltip
      isTabbable={false}
      tooltipText="Closing an activity pack hides it from students. You can still access it in your reports."
      tooltipTriggerText={closeButton}
    />
  )

  const reopenButton = (
    <button className="quill-button borderless small grey icon focus-on-light" onClick={handleClickShowReopenUnit} type="button">
      <img alt="" src={openActivityPackSrc} />
      <span>Reopen Activity Pack</span>
    </button>
  )

  const reopenElement = (
    <Tooltip
      isTabbable={false}
      tooltipText="Reopening an activity pack makes it visible to students."
      tooltipTriggerText={reopenButton}
    />
  )

  const deleteButton = (
    <button className="quill-button borderless small grey icon focus-on-light" onClick={handleClickShowRemove} type="button">
      <img alt="" src={deleteActivityPackSrc} />
      <span>Delete Activity Pack</span>
    </button>
  )

  const deleteElement = (
    <Tooltip
      isTabbable={false}
      tooltipText="Deleting an activity pack is permanent and removes it from your reports."
      tooltipTriggerText={deleteButton}
    />
  )

  return (
    <div className="right-side">
      {isOpen && shareButton}
      {renameButton}
      {isOpen ? closeElement : reopenElement}
      {deleteElement}
    </div>
  )
}

export default ActivityPackUpdateButtons
